const PaymentIcon = ({ color = '#233F72', width = '21', height = '18' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 14V6V6.325V2V14ZM2 4H18V2H2V4ZM9.675 16H2C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V7.25C19.4 6.83333 18.75 6.52083 18.05 6.3125C17.35 6.10417 16.6333 6 15.9 6C15 6 14.1333 6.175 13.3 6.525C12.4667 6.875 11.7333 7.36667 11.1 8H2V14H9.075C9.125 14.35 9.2 14.6917 9.3 15.025C9.4 15.3583 9.525 15.6833 9.675 16ZM17.675 15.375L18.375 14.675L16.5 12.8V10H15.5V13.2L17.675 15.375ZM16.025 18C14.625 18 13.4375 17.5167 12.4625 16.55C11.4875 15.5833 11 14.4 11 13C11 11.6 11.4875 10.4167 12.4625 9.45C13.4375 8.48333 14.625 8 16.025 8C17.4083 8 18.5833 8.4875 19.55 9.4625C20.5167 10.4375 21 11.6167 21 13C21 14.3833 20.5167 15.5625 19.55 16.5375C18.5833 17.5125 17.4083 18 16.025 18Z"
      fill={color}
    />
  </svg>
);

export default PaymentIcon;
